import { render, staticRenderFns } from "./MantraList.vue?vue&type=template&id=1c2cd87e&scoped=true&"
import script from "./MantraList.vue?vue&type=script&lang=js&"
export * from "./MantraList.vue?vue&type=script&lang=js&"
import style0 from "./MantraList.vue?vue&type=style&index=0&id=1c2cd87e&lang=scss&scoped=true&"
import style1 from "./MantraList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2cd87e",
  null
  
)

export default component.exports